import type * as React from 'react';
import { cn } from '@/lib/utils';

/** Placeholder block for async regions that take > 300 ms (DESIGN_SYSTEM §4). */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn('animate-pulse rounded-sm bg-surface-muted', className)}
      {...props}
    />
  );
}

export { Skeleton };
